import { GoalMetric, MetricEntry } from '@griply/types';

import { calculateMetricEntryValue } from '../calculate-metric-entry-value';

// On equal dates the earlier array entry wins. An unconverted date has no position, so it loses.
export const getLatestMetricEntry = (
  entries: MetricEntry[],
): MetricEntry | undefined =>
  entries.reduce<MetricEntry | undefined>((latest, entry) => {
    if (!(entry.date instanceof Date)) {
      return latest;
    }
    return !latest || entry.date.getTime() > latest.date.getTime()
      ? entry
      : latest;
  }, undefined);

export const getLatestMetricValue = (
  metric: GoalMetric | null | undefined,
): number | undefined => {
  // A Relative entry makes calculateMetricEntryValue sort the whole array, so filter once here.
  const entries = (metric?.entries ?? []).filter(
    (entry) => entry.date instanceof Date,
  );
  const latestEntry = getLatestMetricEntry(entries);

  return latestEntry
    ? calculateMetricEntryValue(
        latestEntry.id,
        entries,
        metric?.startValue ?? 0,
      )
    : undefined;
};
